import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

import Header from '../../sections/Header/Header';
import Footer from '../../sections/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import TextContent from '../../components/Section/TextContent/TextContent';
import TitleBar from '../../components/TitleBar/TitleBar';

import PreviewSlider from '../../components/Slider/PhotoSlider/PhotoSlider';

import splash01 from '../../../assets/images/splash/splash-01.jpg';
import splash02 from '../../../assets/images/splash/splash-02.jpg';
import splash03 from '../../../assets/images/splash/splash-03.jpg';
import splash04 from '../../../assets/images/splash/splash-04.jpg';
import mosaic01 from '../../../assets/images/mosaic/mph01.jpg';
import mosaic02 from '../../../assets/images/mosaic/mph02.jpg';
import mosaic03 from '../../../assets/images/mosaic/mph03.jpg';
import mosaic04 from '../../../assets/images/mosaic/mph04.jpg';
import mosaic05 from '../../../assets/images/mosaic/mph05.jpg';
import mosaic06 from '../../../assets/images/mosaic/mph06.jpg';
import mosaic07 from '../../../assets/images/mosaic/mph07.jpg';
import mosaic08 from '../../../assets/images/mosaic/mph08.jpg';
import mosaic09 from '../../../assets/images/mosaic/mph09.jpg';
import mosaic10 from '../../../assets/images/mosaic/mph010.jpg';
import mosaic11 from '../../../assets/images/mosaic/mph011.jpg';
import mosaic12 from '../../../assets/images/mosaic/mph012.jpg';
import { getPublicModels, isPremiumActive, modelProfilePath } from '../../../services/modelService';
import { getModelPhotos } from '../../../util/ModelPhotos';

const splashImages = [
    splash01,
    splash02,
    splash03,
    splash04,
];

const mosaicImages = [
    mosaic01,
    mosaic02,
    mosaic03,
    mosaic04,
    mosaic05,
    mosaic06,
    mosaic07,
    mosaic08,
    mosaic09,
    mosaic10,
    mosaic11,
    mosaic12,
];

export const selectFeaturedModels = (models, limit = 4) => {
    const availableModels = Array.isArray(models) ? models : [];
    const featuredModels = availableModels.filter(isPremiumActive);
    const topModels = availableModels.filter((model) => !isPremiumActive(model));
    return [...featuredModels, ...topModels].slice(0, limit);
};

const Home = () => {
    const [featuredModels, setFeaturedModels] = useState([]);
    const [activeSplash, setActiveSplash] = useState(0);

    useEffect(() => {
        let mounted = true;
        getPublicModels().then((models) => {
            if (mounted) setFeaturedModels(selectFeaturedModels(models));
        }).catch(() => {
            if (mounted) setFeaturedModels([]);
        });
        return () => { mounted = false; };
    }, []);

    useEffect(() => {
        const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) return undefined;

        const splashTimer = window.setInterval(() => {
            setActiveSplash((currentSplash) => (currentSplash + 1) % splashImages.length);
        }, 3500);

        return () => window.clearInterval(splashTimer);
    }, []);

    return (
        <>
            <SEO title="Elite Adult Entertainment Agency Rome & Milan" description="SADIDA Network - premier adult entertainment and escort agency in Rome and Milan, Italy. Custom fantasy experiences, elite talent, and luxury arrangements." />
            <Header />
            <section className="home-splash">
                <div className="home-splash-slides" aria-hidden="true">
                    {splashImages.map((image, index) => (
                        <div
                            className={`home-splash-slide${index === activeSplash ? ' is-active' : ''}`}
                            data-splash-index={index}
                            key={image}
                            style={{backgroundImage: `url("${image}")`}}
                        />
                    ))}
                </div>
                <div className="home-splash-progress" aria-hidden="true">
                    <div className="home-splash-progress-bar" key={activeSplash} />
                </div>
                <a className="home-splash-scroll-cue" href="#home-agency" aria-label="Scroll to agency information">
                    <span aria-hidden="true" />
                </a>
                <div className="main-wrap">
                    <div className="main-frame">
                        <div className="view-container">
                            <div className="intro">
                                <div className="intro-text">
                                    <p>We turn your fantasies into reality.</p>
                                    <p>Adult entertainment brand.</p>
                                </div>
                                <div className="intro-cta">
                                    <Link to={'/talent'}>Talent</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <TextContent type="dark" id="home-agency" content={
                <>
                    <p>
                        SADIDA Network, known as <u>All Day I Dream About Sex</u>, in reverse, is an adult entertainment consulting agency based in Rome, Italy. 
                        Our work is inspired by the rich history and opulent lifestyle of the Roman Empire. We are dedicated to bringing your deepest 
                        fantasies to life with a touch of Roman elegance and decadence.
                    </p>
                </>
            }
            title="The Agency"
            />
            <section className="photo-content">
                <div className="photo-collage">
                    <div className="collage-col">
                        <div className="collage-item tall" style={{backgroundImage:`url(${mosaicImages[0]})`}}></div>
                        <div className="collage-item short" style={{backgroundImage:`url(${mosaicImages[1]})`, backgroundPosition:'center 90%'}}></div>
                        <div className="collage-item" style={{backgroundImage:`url(${mosaicImages[2]})`, backgroundPosition:'center 10%'}}></div>
                    </div>
                    <div className="collage-col">
                        <div className="collage-item" style={{backgroundImage:`url(${mosaicImages[5]})`}}></div>
                        <div className="collage-item tall" style={{backgroundImage:`url(${mosaicImages[4]})`, backgroundPosition:'left center'}}></div>
                        <div className="collage-item short" style={{backgroundImage:`url(${mosaicImages[3]})`, backgroundPosition:'center 55%'}}></div>
                    </div>
                    <div className="collage-col">
                        <div className="collage-item short" style={{backgroundImage:`url(${mosaicImages[6]})`}}></div>
                        <div className="collage-item tall" style={{backgroundImage:`url(${mosaicImages[7]})`, backgroundPosition:'left 60%'}}></div>
                        <div className="collage-item" style={{backgroundImage:`url(${mosaicImages[8]})`, backgroundPosition:'left 60%'}}></div>
                    </div>
                    <div className="collage-col">
                        <div className="collage-item" style={{backgroundImage:`url(${mosaicImages[9]})`, backgroundPosition:'center 40%'}}></div>
                        <div className="collage-item short" style={{backgroundImage:`url(${mosaicImages[10]})`, backgroundPosition:'right center'}}></div>
                        <div className="collage-item tall" style={{backgroundImage:`url(${mosaicImages[11]})`, backgroundPosition:'center 40%'}}></div>
                    </div>
                </div>
            </section>
            <TextContent type="dark" content={
                    <>
                        <p> 
                            Our team of professionals will meticulously recreate your vision, ensuring every detail is perfect. 
                            From the ambiance to the colors, the feelings to the surroundings, we make sure you experience every second 
                            of your dream in the most vivid way possible.
                        </p>
                        <div className="home-cta">
                            <Link to={'/fantasy'}>Custom Fantasy</Link>
                        </div>
                    </>
                }
                title = "What We Do"
            />
            <TitleBar title={'Featured Talent'} />
            <section className="talent-wall featured-talent-wall">
                {featuredModels.map((model, index) => (
                    <PreviewSlider
                        key={`${model.uuid || model.slug || model.name}-${index}`}
                        col={4}
                        images={getModelPhotos(model)}
                        name={model.name}
                        city={model.city}
                        link={modelProfilePath(model.citySlug || model.city, model)}
                        featured={isPremiumActive(model)}
                        showFeaturedBadge={false}
                        showFeaturedBorder={false}
                    />
                ))}
            </section>
            <div className="home-talent-cta">
                <Link to="/talent">View All</Link>
            </div>
            <Footer />
        </>
    )
}

export default Home;